import {Photo} from '../photo/photo.entity';
import {DateTime} from 'luxon';

export enum BookingStatus {
  pending = 'pending',
  payed = 'payed',
  accepted = 'accepted',
  shooting_done = 'shooting_done',
  done = 'done',
  cancelled = 'cancelled'
}

export interface BookingService
{
  id: number;
  name: string;
  photographerId: number;
  photographerSlug: string;
  photographerName: string;
  price: number;
  publicPrice: number;
  commission: number;
  image: string|null;
  discountActive?: boolean|null;
  discount?: number|null;
}

export interface BookingCustomer
{
  id: number;
  email: string;
  firstname: string|null;
  lastname: string|null;
}

export interface Booking
{
  id: number;
  service: BookingService;
  price: number;
  publicPrice: number;
  commission: number;
  depositPercent?: number|null;
  depositAmount?: number|null;
  depositStatus?: BookingBalanceStatus|null;
  balanceAmount?: number|null;
  balanceStatus?: BookingBalanceStatus|null;
  /**
   * Balance due date when applicable.
   */
  balanceDueAt?: DateTime|null;
  paymentMethodId?: string|null;
  paymentBreakdown?: BookingPaymentBreakdown[];
  customer: BookingCustomer;
  datetime: DateTime;
  photos: Photo[];
  createdAt: DateTime|null;
  updatedAt: DateTime|null;
  deletedAt: DateTime|null;
  invoiceUrl: string|null;
  note: string|null;
  status: string;
}

export type BookingBalanceStatus = 'pending'|'paid'|'failed'|string;

export interface BookingPaymentBreakdown {
  type: string;
  amount: number;
  status: BookingBalanceStatus|null;
  dueAt: DateTime|null;
}
